import React, { useState, useEffect } from "react";
import { Nav, NavItem, NavLink } from "shards-react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SignatureFields from "../../Toolbars/components/SignatureFields";

const DragAndDropTabs = ({
  worksteps,
  handleWorkstepsChange,
  fieldsNames,
  isNewEnvelope,
  extractedFields,
  fieldDisplayNames,
  formInputClasses,
  handleInputChange,
  approved,
  modifyFieldValue,
  checkAllFields,
  setCheckAllFields,
  setMessage,
  formRef,
  signatureType,
  setSendTo,
  modulesOnFinish,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [dragTab, setDragTab] = useState(0);
  const [ws, setWS] = useState([]);

  const updateActiveTab = (e, index) => {
    setActiveTab(index);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const handleDragUpdate = (result) => {
    if (!result.destination) {
      return;
    }

    setDragTab(activeTab);
    setActiveTab(-1);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(ws, result.source.index, result.destination.index);

    handleWorkstepsChange(items);

    setActiveTab(result.destination.index);

    setWS(items);
  };

  const getItemStyle = (isDragging, draggableStyle) => {
    if (isDragging) {
      return {
        backgroundColor: "lightgreen",
        ...draggableStyle,
      };
    }
    return {
      ...draggableStyle,
    };
  };

  const isAllFieldsInWorkstepsFilled = () => {
    let ret = null;
    const mobilePattern = /^\+\d+[ 0-9]{7,}$/;

    for (let x = 0; x < worksteps.length; x++) {
      const workstep = worksteps[x];
      for (let y = 0; y < fieldsNames.length; y++) {
        const fieldsName = fieldsNames[y];

        if (workstep[fieldsName] === "") {
          if (
            (signatureType !== undefined && signatureType === "trusted") ||
            workstep.sms_auth
          ) {
            ret = {
              workstep_idx: x,
              fieldDisplayName: fieldDisplayNames[y],
              message: "Bitte " + fieldDisplayNames[y] + " ausfüllen",
            };
            break;
          } else {
            if (fieldsName !== "mobile") {
              ret = {
                workstep_idx: x,
                fieldDisplayName: fieldDisplayNames[y],
                message: "Bitte " + fieldDisplayNames[y] + " ausfüllen",
              };
              break;
            }
          }
        } else if (
          fieldsName === "mobile" &&
          !mobilePattern.test(workstep[fieldsName])
        ) {
          ret = {
            workstep_idx: x,
            fieldDisplayName: fieldDisplayNames[y],
            message: "Das Format soll +XX XXXXXXXX sein.",
          };
          break;
        }
      }
      if (ret !== null) {
        break;
      }
    }
    return ret;
  };

  useEffect(() => {
    if (worksteps) {
      setWS(worksteps);
    }
  }, [worksteps]);

  useEffect(() => {
    if (checkAllFields !== null) {
      const ret = isAllFieldsInWorkstepsFilled();
      if (ret !== null) {
        setActiveTab(ret.workstep_idx);
        setMessage({ msg: ret.message });
      } else {
        formRef.current.requestSubmit();
      }

      if (typeof setSendTo === "function") {
        setSendTo(null);
      }
      setCheckAllFields(null);
    }
  }, [checkAllFields]);

  const closeTab = (index) => {
    if (ws.length === 1) {
      // Prevent removal if there is only one tab
      return;
    }
    const updatedWorksteps = [...ws];
    updatedWorksteps.splice(index, 1); //Remove
    setWS(updatedWorksteps);

    //Update activeTab
    if (activeTab === index) {
      setActiveTab(Math.min(index, updatedWorksteps.length - 1));
    } else if (activeTab > index) {
      setActiveTab(activeTab - 1);
    }

    handleWorkstepsChange(updatedWorksteps);
  };

  return !isNewEnvelope ? (
    <></>
  ) : (
    <>
      <DragDropContext
        onDragUpdate={handleDragUpdate}
        onDragEnd={handleDragEnd}
      >
        <Droppable droppableId="droppable-worksteps" direction={"horizontal"}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <Nav tabs>
                {ws.map((x, index) => {
                  return (
                    <Draggable
                      key={index}
                      draggableId={"draggable-" + index}
                      index={index}
                      isDragDisabled={!(index === activeTab)}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <NavItem
                            key={index}
                            style={{
                              position: "relative",
                              paddingLeft: "20px",
                            }}
                          >
                            <NavLink
                              tag={"div"}
                              className="tab-text pointer"
                              active={index === activeTab}
                              onClick={(e) => updateActiveTab(e, index)}
                            >
                              {x.workstep_id}
                              {ws.length > 1 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "red",
                                    padding: "5px",
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    closeTab(index);
                                  }}
                                >
                                  ×
                                </span>
                              )}
                            </NavLink>
                          </NavItem>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
              </Nav>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {ws.length > 0 && (
        <SignatureFields
          fieldsNames={fieldsNames}
          isNewEnvelope={isNewEnvelope}
          extractedFields={extractedFields}
          workstep={ws[activeTab === -1 ? dragTab : activeTab]}
          fieldDisplayNames={fieldDisplayNames}
          formInputClasses={formInputClasses}
          handleInputChange={handleInputChange}
          approved={approved}
          modifyFieldValue={modifyFieldValue}
          signatureType={signatureType}
          modulesOnFinish={modulesOnFinish}
        />
      )}
    </>
  );
};

export default DragAndDropTabs;
